/* eslint-disable  */
import Flowit from "../../../services/flowit";
import * as types from "./types";

export const loadAccount = ({ commit }) => {
  Flowit.account.getAnticipationRule().then(response => {
    commit(types.ANTICIPATION_RULE, response.data.rule);
    if (response.data.rule === "automatic") {
      commit(types.AUTOMATIC_ANTICIPATION_ENABLED, true);
    } else {
      commit(types.AUTOMATIC_ANTICIPATION_ENABLED, false);
    }
  });

  Flowit.account.getAnticipationTax().then(response => {
    commit(types.ANTICIPATION_TAX, response.data.tax);
  });

  Flowit.account.getBalance().then(response => {
    commit(types.BALANCE, response.data.balance);
  });
};

export const getAnticipationTax = ({ commit }) => {
  Flowit.account.getAnticipationTax().then(response => {
    commit(types.ANTICIPATION_TAX, response.data.tax);
  });
};

export const disableAutomaticAnticipations = ({ commit }) => {
  Flowit.account.disableAutomaticAnticipations().then(response => {
    // console.log(`Status on fetch: ${response.data.status}`);
    if (response.data.status === "disabled") {
      commit(types.AUTOMATIC_ANTICIPATION_ENABLED, false);
      commit(types.ANTICIPATION_RULE, "manual");
      /* localStorage.setItem(
        AUTOMATIC_ANTICIPATION_ENABLED,
        JSON.stringify(AUTOMATIC_ANTICIPATION_ENABLED)
      ); */
    }
  });
};

export const cancelAutomaticAnticipationProccess = ({ commit }) => {
  commit(types.AUTOMATIC_ANTICIPATION_ENABLED, false);
  commit(types.ANTICIPATION_RULE, "manual");
};

export const loadAnticipationRequestStatus = ({ commit }) => {
  Flowit.account.anticipationRequestStatus().then(response => {
    commit(types.ANTICIPATION_REQUEST_PENDING, !!response.data.pending);
  });
};

// The toggle and the pontual flow no longer act directly; they drop a request
// in the backoffice queue. Accepts a kind string (automatic on/off) or a full
// payload (pontual with deposit_ids/amount). Returns a promise so the caller
// can react to success/failure.
export const requestAnticipation = ({ commit }, payload) => {
  const params = typeof payload === "string" ? { kind: payload } : payload;
  return Flowit.account
    .createAnticipationRequest(params)
    .then(() => {
      commit(types.ANTICIPATION_REQUEST_PENDING, true);
      return true;
    })
    .catch(() => false);
};

export const enableAutomaticAnticipations = ({ commit }) => {
  Flowit.account.enableAutomaticAnticipations().then(response => {
    // console.log(`Status on fetch: ${response.data.status}`);
    if (response.data.status === "enabled") {
      commit(types.AUTOMATIC_ANTICIPATION_ENABLED, true);
      commit(types.ANTICIPATION_RULE, "automatic");
    }
  });
};

export const getBalance = ({ commit }) => {
  Flowit.account.getBalance().then(response => {
    commit(types.BALANCE, response.data.balance);
  });
};

export const getAnticipationsAvailable = ({ commit }, params) => {
  commit(types.ANTICIPATIONS_AVAILABLE_LOADING, true);
  Flowit.account.anticipationsAvailable(params).then(response => {
    commit(types.ANTICIPATIONS_AVAILABLE, response.data.resources);
    commit(types.ANTICIPATIONS_AVAILABLE_COUNT, response.data.count);
    commit(types.CURRENT_TAX, response.data.tax);
    commit(types.ANTICIPATIONS_AVAILABLE_LOADING, false);
  }, params);
};

export const createAnticipations = ({ commit }, params) => {
  Flowit.account.createAnticipations(params).then(response => {
    // console.log(response);
  });
};

export const setSelectAnticipations = ({ commit }, anticipations) => {
  commit(types.SELECTED_ANTICIPATIONS, anticipations);
};

export const updateSelectedAnticipations = ({ commit }, items) => {
  commit(types.SELECTED_ANTICIPATIONS, items);
};
export const updateSelectedAnticipationsAmount = ({ commit }, amount) => {
  commit(types.SELECTED_ANTICIPATIONS_AMOUNT, amount);
};

export const updateAnticipationsAvailableLimit = ({ commit }, limit) => {
  commit(types.ANTICIPATIONS_AVAILABLE_LIMIT, limit);
};

export const updateAnticipationsAvailablePage = ({ commit }, page) => {
  commit(types.ANTICIPATIONS_AVAILABLE_PAGE, page);
};
